import React from "react";

import Button from "../../../../../../../components/Button";
//components
import Modal from "../../../../../../../components/Modal";
import Typography from "../../../../../../../components/Text";

//css
import css from "../../SurveyQuestions.module.scss";

type ModalProps = {
	isOpen: boolean;
	maxAllowedQuestions: number;
	onClose: () => void;
};

const MaxQuestionsReachedModal = ({ isOpen, maxAllowedQuestions, onClose }: ModalProps) => {
	if (!isOpen) return null;

	return (
		<Modal
			content={
				<Typography weight="semi-bold" size="paragraph-1" className={css.maxQuestionsModal}>
					You have reached the maximum {maxAllowedQuestions} Custom Question limit. Consider removing old
					questions to free up more space.
				</Typography>
			}
			buttons={
				<Button color="green" onClick={onClose}>
					Close
				</Button>
			}
			handleClose={onClose}
			size="large"
		/>
	);
};

export default MaxQuestionsReachedModal;
